import Axios from "../../../../networking/intraceptor";
import * as endPoints from '../../../../networking/urlEndPoints';
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
const token = Cookies.get('authToken');
// Helper function to generate action types with REQUEST, SUCCESS, and FAILURE
// This function takes a base string and returns an object with three properties: REQUEST, SUCCESS, and FAILURE, each suffixed to the base string.
const createActionTypes = (base) => ({
    REQUEST: `${base}_REQUEST`,
    SUCCESS: `${base}_SUCCESS`,
    FAILURE: `${base}_FAILURE`
});

// Action Types
export const actionTypes = {
    FETCH_PATIENT_DATA: createActionTypes('FETCH_PATIENT_DATA'),
    UPDATE_PATIENT_DATA: createActionTypes('UPDATE_PATIENT_DATA'),
    UPDATE_PATIENT_PROFILE_IMAGE: createActionTypes('UPDATE_PATIENT_PROFILE_IMAGE'),
    FETCH_ACTIVE_MEDICINE_LIST: createActionTypes('FETCH_ACTIVE_MEDICINE_LIST'),
    FETCH_ALL_MEDICINE_LIST: createActionTypes('FETCH_ALL_MEDICINE_LIST'),
    FETCH_BLISTER_MEDICINE_LIST: createActionTypes('FETCH_BLISTER_MEDICINE_LIST'),
    FETCH_PHARMACY_DRIVER_HCP_LIST: createActionTypes('FETCH_PHARMACY_DRIVER_HCP_LIST'),
    UPDATE_PATIENT_VITAL_DRIVER: createActionTypes('UPDATE_PATIENT_VITAL_DRIVER'),
    FETCH_PATIENT_VITALS: createActionTypes('FETCH_PATIENT_VITALS'),
    FETCH_PATIENT_VITAL_AND_HCP_DRIVER: createActionTypes('FETCH_PATIENT_VITAL_AND_HCP_DRIVER')
};

// Action Creators
// This function creates an action object with a given type and optional payload.
export const createAction = (type, payload = {}) => ({ type, payload });


// Fetches the pick route logs based on the provided parameters and dispatches the appropriate actions based on the API response.
let getPatientDataAbortControllers = []
export const FetchPatientData = ({ fetchType,  params }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    getPatientDataAbortControllers.forEach(controller => controller.abort());
    getPatientDataAbortControllers = []; // Clear the array
    
    // 🆕 Create new controller
    const controller = new AbortController();
    getPatientDataAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PATIENT_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.patientProfile_getPatientProfile}`, { params, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PATIENT_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data   
           
        }
        
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_PATIENT_DATA.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};


export const UpdatePatientData = ({ fetchType,  params, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_PATIENT_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.patientProfile_updatePatientProfile}`, params, {params: {id} } );
        if (status === 200) {
                // dispatch(FetchPatientData({ fetchType: 'patientData', params: {id} }));
                dispatch(createAction(actionTypes.UPDATE_PATIENT_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            toast.success('Patient data updated successfully');
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_PATIENT_DATA.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong');
    }
};


export const UpdatePatientProfileImage = ({ fetchType, params, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_PATIENT_PROFILE_IMAGE.REQUEST, {
        requestType: fetchType
    }));
    const url = `${process.env.REACT_APP_BASE_URL}pharmacy-patient-profile/update-patient-profile`
    try {
        const { status, data } = await axios.post(url, params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                }
            }
        );
        if (status === 200) {
            dispatch(FetchPatientData({ fetchType: 'patientData', params: {id} }));
            dispatch(createAction(actionTypes.UPDATE_PATIENT_PROFILE_IMAGE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            toast.success('Profile image updated successfully');
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_PATIENT_PROFILE_IMAGE.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong');
    }
}


let getAllMedicineListAbortControllers = []
export const FetchAllMedicineList = ({ fetchType, params, pageNumber }) => async (dispatch) => {

    // Only abort previous requests if it's the first page (initial load)
    if (pageNumber === 1) {
        getAllMedicineListAbortControllers.forEach(controller => controller.abort());
        getAllMedicineListAbortControllers = [];
    }
    
    const controller = new AbortController();
    getAllMedicineListAbortControllers.push(controller);
    
    // Only show loading for first page
    if (pageNumber === 1) {
        dispatch(createAction(actionTypes.FETCH_ALL_MEDICINE_LIST.REQUEST, {
            requestType: fetchType
        }));
    }

    const payload = {
        page: pageNumber,
        patient_id: params.patient_id
      }
    

    try {
        const { status, data } = await Axios.get(endPoints.patientProfile_AllMedicineList, { params: payload, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_ALL_MEDICINE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType  
            }));
            return data
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_ALL_MEDICINE_LIST.FAILURE, {
            error: errMsg,  
            requestType: fetchType
        }));
    }
}

let getActiveMedicineListAbortControllers = []
export const FetchBlisterMedicineList = ({ fetchType, params }) => async (dispatch) => {

    dispatch(createAction(actionTypes.FETCH_BLISTER_MEDICINE_LIST.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.patientProfile_BlisterMedicineList, { params });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_BLISTER_MEDICINE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_BLISTER_MEDICINE_LIST.FAILURE, {
            error: error?.response?.data?.message || error?.message,
            requestType: fetchType
        }));
    }
};

export const FetchActiveMedicineList = ({ fetchType, params }) => async (dispatch) => {

    getActiveMedicineListAbortControllers.forEach(controller => controller.abort());
    getActiveMedicineListAbortControllers = [];
    const controller = new AbortController();
    getActiveMedicineListAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_ACTIVE_MEDICINE_LIST.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.patientProfile_ActiveMedicineList, {params, signal: controller.signal});
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_ACTIVE_MEDICINE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType  
            }));
            return data
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_ACTIVE_MEDICINE_LIST.FAILURE, {
            error: errMsg,  
            requestType: fetchType
        }));
    }
}

let getPharmacyDriverHcpListAbortControllers = []
export const FetchPharmacyDriverHcpList = ({ fetchType, params }) => async (dispatch) => {
    // Only cancel previous requests if they're still pending
    getPharmacyDriverHcpListAbortControllers.forEach(controller => {
        if (controller.signal && !controller.signal.aborted) {
            controller.abort();
        }
    });
    getPharmacyDriverHcpListAbortControllers = [];
    const controller = new AbortController();
    getPharmacyDriverHcpListAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PHARMACY_DRIVER_HCP_LIST.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.pharmacy_driver_hcp_list, { params, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PHARMACY_DRIVER_HCP_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_PHARMACY_DRIVER_HCP_LIST.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
}

export const UpdatePatientVitalDriver = ({ fetchType, params, patient_id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_PATIENT_VITAL_DRIVER.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(endPoints.patientProfile_updatePatientVitalDriver, params, { params: { id: patient_id } });
        if (status === 200) {
            dispatch(createAction(actionTypes.UPDATE_PATIENT_VITAL_DRIVER.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            // Use API response message if available, otherwise use default message
            const successMessage = data?.message ;
            toast.success(successMessage);
            return data
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_PATIENT_VITAL_DRIVER.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Failed to update patient vital driver');
    }
}

let getPatientVitalsAbortControllers = []
export const FetchPatientVitals = ({ fetchType, params }) => async (dispatch) => {
    // Cancel ALL previous requests before new one starts
    getPatientVitalsAbortControllers.forEach(controller => controller.abort());
    getPatientVitalsAbortControllers = []; // Clear the array
    
    // Create new controller
    const controller = new AbortController();
    getPatientVitalsAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PATIENT_VITALS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.patientProfile_getPatientVitals}`, { params, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PATIENT_VITALS.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data   
        }
        
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_PATIENT_VITALS.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};

let getPatientVitalAndHcpDriverAbortControllers = []
export const FetchPatientVitalAndHcpDriver = ({ fetchType, params }) => async (dispatch) => {
    // Cancel ALL previous requests before new one starts
    getPatientVitalAndHcpDriverAbortControllers.forEach(controller => controller.abort());
    getPatientVitalAndHcpDriverAbortControllers = []; // Clear the array
    
    // Create new controller
    const controller = new AbortController();
    getPatientVitalAndHcpDriverAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PATIENT_VITAL_AND_HCP_DRIVER.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.patientProfile_getPatientVitalAndHcpDriver}`, { params, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PATIENT_VITAL_AND_HCP_DRIVER.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data   
        }
        
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_PATIENT_VITAL_AND_HCP_DRIVER.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};


const stateKeys = [
    'patientData',
    'updatePatientData',
    'updatePatientProfileImage',
    'activeMedicineList',
    'allMedicineList',
    'blisterMedicineList',
    'pharmacyDriverHcpList',
    'updatePatientVitalDriver',
    'patientVitals',
    'patientVitalAndHcpDriver'
];

const createDefaultState = () => ({
    loading: false,
    error: null,
    data: null,
    fetchType: null,
});

const initialState = stateKeys.reduce((acc, key) => {
    acc[key] = createDefaultState();
    return acc;
}, {});

// Helper function to update state
const updateState = (state, key, updates) => ({
    ...state,
    [key]: { ...state[key], ...updates }
});

// Map action prefixes to state keys
const actionPrefixMap = {
    FETCH_PATIENT_DATA: 'patientData',
    UPDATE_PATIENT_DATA: 'updatePatientData',
    UPDATE_PATIENT_PROFILE_IMAGE: 'updatePatientProfileImage',
    FETCH_ACTIVE_MEDICINE_LIST: 'activeMedicineList',
    FETCH_ALL_MEDICINE_LIST: 'allMedicineList',
    FETCH_BLISTER_MEDICINE_LIST: 'blisterMedicineList',
    FETCH_PHARMACY_DRIVER_HCP_LIST: 'pharmacyDriverHcpList',
    UPDATE_PATIENT_VITAL_DRIVER: 'updatePatientVitalDriver',
    FETCH_PATIENT_VITALS: 'patientVitals',
    FETCH_PATIENT_VITAL_AND_HCP_DRIVER: 'patientVitalAndHcpDriver'
};

// Helper function to get updates based on action status
const getStatusUpdates = (status, payload) => ({
    REQUEST: { loading: true, data: null, error: null, fetchType: payload.requestType },
    SUCCESS: { 
        loading: false, 
        error: null, 
        data: payload.data, 
        fetchType: payload.requestType 
    },
    FAILURE: { loading: false, error: payload.error, data: null, fetchType: payload.requestType }
}[status]);

// Reducer
const PatientProfileReducer = (state = initialState, { type, payload }) => {
    const typeParts = type.split('_');
    const status = typeParts.pop();
    const prefix = typeParts.join('_');
    const key = actionPrefixMap[prefix];

    if (!key) return state;

    // Special handling for allMedicineList pagination
    if (key === 'allMedicineList' && status === 'SUCCESS' && state[key].data) {
        // If we have existing data, append new prescriptions to it
        const existingPrescriptions = state[key].data?.data?.prescriptions || [];
        const newPrescriptions = payload.data?.data?.prescriptions || [];
        
        return updateState(state, key, {
            loading: false,
            error: null,
            data: {
                ...payload.data,
                data: {
                    ...payload.data.data,
                    prescriptions: [...existingPrescriptions, ...newPrescriptions]
                }
            },
            fetchType: payload.requestType
        });
    }

    const updates = getStatusUpdates(status, payload);
    return updates ? updateState(state, key, updates) : state;
};

export default PatientProfileReducer;
